import React from "react";
import LmsTable from "../ui/LmsTable";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { IDefaultPagesProps } from "../../interfaces/Lms";

const LmsLoanAssignment = ({ id }) => {
  const [{ data, error, isLoading }] = useFetchData(`loans/assignments/${id}`);
  const myForm = new BCFormController(data, { isCompact: true });
  myForm.addCenteredGroup([
    myForm.getDisplayField("Loan #", { name: "loanNumber" }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Borrower"),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Special Purpose Entity", { name: "spe" }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Property Address"),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Project Name"),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Parcel #", { name: "parcelNumbers" }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Assignment Order"),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Assignment Type", { name: "assignmentTypeDisplay" }),
  ]);
  myForm.addCenteredGroup([
    myForm.getCheckboxField("Assignment Created", { disabled: true }),
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Transfer Date", { disabled: true }),
  ]);
  myForm.addDividerField({ dividerIsHidden: true });
  myForm.addCenteredGroup([
    myForm.getComponent(<LmsTable apiSuffix={`loans/assignments/${id}/history`} title="Previous Recording Detail" isDisabled />),
  ], { blankWidth: 2 });
  myForm.addDividerField({ dividerIsHidden: true });
  myForm.addDividerField({ dividerText: "Recording Detail" });
  myForm.addGroupFields([
    myForm.getDisplayField("Assignment Type", { name: "assignmentTypeDisplay" }),
    myForm.getDisplayField("Current Organization", { name: "currentOrganizationDisplay" }),
    myForm.getDisplayField("New Organization", { name: "newOrganizationDisplay" }),
    myForm.getInputField("Recording Number", { isDisabledOn: { assignmentCreated: false } }),
    myForm.getCalendarField("Recording Date", { isDisabledOn: { assignmentCreated: false } }),

  ]);
  myForm.addDividerField();
  myForm.addDividerField({ dividerIsHidden: true });
  myForm.addCenteredGroup([
    myForm.getDisplayField("Fedex Number"),
  ]);
  myForm.addCenteredGroup([
    myForm.getDisplayField("Fedex Sent To"),
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Request To Be Returned Date", { disabled: true }),
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Received Asset Back Date", { disabled: true }),
  ]);
  myForm.addCenteredGroup([
    myForm.getCheckboxField("Assignment Not Required", { disabled: true }),
  ]);

  return <>
    <LmsFormGenerator myForm={myForm} actions={["close"]} isLoading={isLoading} error={error} />
    <LmsTable actionButtons={["export"]} apiSuffix={`loans/assignments/${id}/document-log`} title="Documents" />
  </>;
};

const LmsLoanAssignments = ({ ...props }: IDefaultPagesProps) => {
  const { params = {}, history } = props;
  const { isMainPage, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <>
    {isMainPage && <LmsTable 
      actionButtons={["export"]} 
      apiSuffix="loans/assignments" 
      columnLabelsDictionary={{
        loanNumber: "Loan #",
        assignmentCreatedYesNo: "Assignment Created",
        description: "Comments",
        spe: "SPE",
        assignmentNotRequiredYesNo: "Assignment Required"
      }}
    />}
    {isEdit && <LmsLoanAssignment id={id} />}
  </>;
};

export default LmsLoanAssignments;